import React, { useEffect } from 'react';

import { useFriendlyCaptcha } from '@/components/utils';

import {
  StyledErrorIcon,
  StyledIconContainer,
  StyledIntro,
  StyledProcessingIcon,
  StyledResultButton,
  StyledSuccessIcon,
} from './Newsletter.styled';
import type { IResultStateProps } from './Newsletter.types';

export const ResultStates = {
  processing: 'processing',
  ok: 'ok',
  error: 'error',
  duplicate: 'duplicate',
} as const;

export const ResultState = ({
  resultState,
  resultLabels,
  onHandleButtonError,
  getSolutionHandler,
}: IResultStateProps) => {
  const { FriendlyCaptchaComponent, solution } = useFriendlyCaptcha(
    resultState === ResultStates.processing
  );
  const getIcon = () => {
    switch (resultState) {
      case ResultStates.ok:
        return <StyledSuccessIcon />;
      case ResultStates.error:
        return <StyledErrorIcon />;
      case ResultStates.duplicate:
        return <StyledProcessingIcon />;
      case ResultStates.processing:
        return <StyledProcessingIcon />;
    }
  };

  useEffect(() => {
    if (solution) {
      getSolutionHandler(solution);
    }
  }, [solution, getSolutionHandler]);

  return (
    <>
      <StyledIconContainer>{getIcon()}</StyledIconContainer>
      <StyledIntro
        headline={{
          label: resultLabels[resultState].headline,
          size: 'h3',
        }}
        subtitle={resultLabels.title}
        copy={resultLabels[resultState].subHeadline}
        nested
      />
      {resultState === ResultStates.processing && FriendlyCaptchaComponent}
      {resultState === ResultStates.error && (
        <StyledResultButton
          label={resultLabels.error.button}
          variant="secondary"
          type="button"
          onClick={onHandleButtonError}
        />
      )}
    </>
  );
};
